import { Link } from "react-router-dom";
import { ShoppingCart, Heart } from "lucide-react";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { useCart } from "@/context/CartContext";
import { api, eur } from "@/lib/api";

export default function ProductCard({ p, index = 0 }) {
  const { add } = useCart();

  const addToCart = (e) => {
    e.preventDefault();
    add(p);
    toast.success("Aggiunto al carrello");
  };

  const toggleWish = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post(`/wishlist/${p.id}`);
      toast.success(data.wishlisted ? "Aggiunto alla wishlist" : "Rimosso dalla wishlist");
    } catch {
      toast.error("Accedi per usare la wishlist");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 24, scale: 0.97 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: (index % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link data-testid={`product-card-${p.id}`} to={`/prodotto/${p.id}`} className="card-product group h-full">
        <div className="relative overflow-hidden aspect-square bg-[#f4f4f0]">
          <img
            src={p.image}
            alt={p.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <button
            data-testid={`wishlist-toggle-${p.id}`}
            onClick={toggleWish}
            aria-label="Wishlist"
            className="absolute top-3 right-3 bg-white border border-[#e5e5e5] p-2 hover:border-[#ff4500] hover:text-[#ff4500] transition-colors"
          >
            <Heart className="w-4 h-4" strokeWidth={1.5} />
          </button>
          {p.stock >= 2 && p.stock <= 5 && (
            <span className="absolute bottom-3 left-3 bg-[#ffd600] text-black text-[10px] font-bold uppercase tracking-wide px-2 py-1">
              Ultimi {p.stock} pezzi
            </span>
          )}
          {p.stock < 2 && (
            <span className="absolute bottom-3 left-3 bg-[#0a0a0a] text-white text-[10px] font-bold uppercase tracking-wide px-2 py-1">
              Esaurito
            </span>
          )}
        </div>
        <div className="p-4 flex flex-col flex-1">
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-muted-foreground">{p.brand}</div>
          <div className="mt-1 font-semibold leading-snug flex-1">{p.name}</div>
          {p.specs?.Passo && <div className="mt-1 text-xs text-muted-foreground font-mono">Passo {p.specs.Passo}{p.specs.Maglie ? ` · ${p.specs.Maglie} maglie` : ""}</div>}
          <div className="mt-3 flex items-center justify-between">
            <span className="font-display font-semibold text-lg text-[#ff4500]">{eur(p.price)}</span>
            <button
              data-testid={`add-to-cart-${p.id}`}
              onClick={addToCart}
              disabled={p.stock < 2}
              aria-label="Aggiungi al carrello"
              className="bg-[#0a0a0a] text-white p-2.5 hover:bg-[#ff4500] transition-colors disabled:opacity-40"
            >
              <ShoppingCart className="w-4 h-4" strokeWidth={2} />
            </button>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
